import {Component, NgZone, OnInit} from '@angular/core';
import {ServiceLogModel} from "../../service-log/models/service-log.model";
import {api, getAlertMessage} from "../../shared/api-loaders";
import {ModalService} from "../../shared/modal.service";
import {PaginationService} from "../../users/services/pagination.service";
import {Router} from "@angular/router";
import {ServiceLogService} from "../services/service-log.service";
import {Alert} from "../../shared/alert.model";
import { HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

//import {ServiceLogModel} from "../models/service-log.model";

@Component({
    selector: 're-service-log-list',
    templateUrl: './service-log-list.component.html',
    styleUrls: ['./service-log-list.component.scss'],
    standalone: false
})
export class ServiceLogListComponent implements OnInit {
  logs: ServiceLogModel[] = [];
  loading: boolean;
  alert: Alert;
  isAuthenticated: boolean;
  limit = 100;
  startsFrom: string;
  url= '';
  request= '';
  response= '';
  statusFilterOptions: string[] = ['Show All', '200 - OK', '201 - Created', '400 - Bad request', '401 - Unauthorized', '403 - Forbidden', '404 - Not Found', '405 - Method Not Allowed', '409 - Conflict',  '500 - Internal Server Error',
    '503 - Service Unavailable'];
  //statusFilterOptions: string[] = ['Show All', '200', '400'];
  selectedStatusFilter = 'Show All';
  apiStatusFilter= '0';
  duration= '';
  traceId= '';
  allowSearch: boolean;

  private nonSearchableChars = /[*\\]/;

  // pagination object
  pagination: any = {};
  // Log list items after pagination
  pagedItems: any[];
  entriesPerPage = 100;
  dataTable: DataTables.Api;
  
  constructor(
    public serviceLogService: ServiceLogService,
    private modalService: ModalService,
    private paginationService: PaginationService,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.url = '';
    this.request = '';
    this.response = '';
    this.duration = '';
    this.traceId = '';
    this.allowSearch = false;

  }

  ngOnDestroy(): void {
    delete window["currentComponent"];
  }

  navigateToRoute(url: string) {

    this.ngZone.run(() => {
      this.router.navigateByUrl(url);
    })
  }

  private serialize(obj:any) {

    return encodeURIComponent(JSON.stringify(obj));
  }

  private deserialize(text: string): any{
    return JSON.parse(decodeURIComponent(text));

  }

  ngOnInit(): void {
    window["currentComponent"] = this;

    let url = api.logs();
    this.dataTable = $('#serviceLogList').DataTable({
      dom:
        '<"row"<"col-sm-12"f>>' +
        '<"row"<"col-sm-12"tr>>' +
        '<"row d-none d-sm-flex"<"col-sm-12"<"float-right"p><"float-right neo-dt-l"l>>>' +
        '<"row d-flex d-sm-none"<"col-sm-6"l><"col-sm-6"p>>' +
        '<"row float-right d-none d-sm-flex"<"col-sm-12"<"float-right neo-dt-i"i>>>' +
        '<"row d-flex d-sm-none"<"col-sm-12"i>>',
      pagingType: 'full_numbers',
      language: {
        'paginate': {
          'first': '<<',
          'previous': '<',
          'next': '>',
          'last': '>>',
        },
        emptyTable: 'No Matching Records Found.',
      },
      ordering: false,
      searching: false,
      paging: true,
      info: true,
      serverSide: true,
      ajax: {
        url: '', beforeSend: (request, settings) => {
         let parameters = this.decodeQueryString(settings.url)
          //argument jQuery needs that incrememnts every time, returning increased value
          let draw = parameters.draw;
        if(!draw) draw=1;

        //settings.url = `${url}?draw=${draw}&url=${encodeURIComponent(this.url)}&startsFrom=${parameters.start}&limit=${parameters.length}`;
        settings.url = `${url}?draw=${draw}&limit=${parameters.length}&startsFrom=${parameters.start}&url=${encodeURIComponent(this.url)}&request=${encodeURIComponent(this.request)}
        &response=${encodeURIComponent(this.response)}&statusCode=${encodeURIComponent(this.apiStatusFilter)}&duration=${encodeURIComponent(this.duration)}&traceId=${encodeURIComponent(this.traceId)}`;
        }},
      columns: [
        {
          title: 'ID', render: (data: any, type: any, s: ServiceLogModel) => {
            return `<a href='javascript:currentComponent.navigateToRoute("/servicelog/${s.id}")'>${s.id}</a>`;
          }
        },
        { data: 'url', title: 'URL' },
        {
          data: 'responseCode', title: 'Status Code' },
        //TODO make status code hyperlink
/*        {
          title: 'Status Code', render: (data: any, type: any, s: ServiceLogModel) => {
            return `<a href='javascript:currentComponent.navigateToRoute("/servicelog/${s.responseCode}")'>${s.responseCode}</a>`;
          }
        },*/
        { data: 'responseDurationMs', title: 'Duration (ms)', defaultContent:"" },
        { data: 'datetime', title: 'Response Date/Time' },
      ]



    });

    new $.fn.dataTable["FixedHeader"](this.dataTable);
    this.getLogs();

  }

  private decodeQueryString(text: string):any {
    let url = decodeURIComponent(text);
    let startIndex = url.indexOf("?");
    if (startIndex == -1)
      return null;
    let parameters = text.substring(startIndex + 1).split('&');
    let ret = {};
    for (var i = 0; i < parameters.length; i++) {
      let p = parameters[i].split('=');
      ret[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
    }
    return ret;

  }

  getLogs(): void {
    let  params = new HttpParams();
    params = params.set('limit', String(this.limit));
    params =params.set('startsFrom', this.startsFrom);
    params =params.set('url', this.url);
    params =params.set('request', this.request);
    params =params.set('reponse', this.response);
    params =params.set('duration', this.duration);
    //params =params.set('daterange', this.datetime);
    params =params.set('traceid', this.traceId);
    params =params.set('statusFilter',
      ((this.selectedStatusFilter === 'Show All') ? '' : this.selectedStatusFilter));

    this.loading = true;
    this.logs = [];
    // with params
    this.serviceLogService
      .getLogs(params)
      .subscribe(
        res => {
          Array.prototype.push.apply(this.logs, res);
          this.paginate(1);
          this.loading = false;
          window.scrollTo(0, 0);
        },
        error => {
          this.alert = getAlertMessage(error);
          this.loading = false;
        });
/*    this.serviceLogService.getLogs()
      .subscribe(logs => { this.logs = logs; this.loading = false; },
        error => {
          this.alert = getAlertMessage(error);
          this.loading = false;
        });*/
  }

  paginate(page: number) {
    // Get pagination object from  pagination service
    this.pagination = this.paginationService.getPaginationObject(this.logs.length, page, this.entriesPerPage);

    // Get current page of log items
    this.pagedItems = this.logs.slice(this.pagination.startIndex, this.pagination.endIndex + 1);

    this.dataTable.clear();
    this.dataTable.rows.add(this.pagedItems);
    this.dataTable.draw();

    //lets recalculate responisvness after the data is loaded so columns that don't fiit in the viewport will be hidden
    ///and move to the details section
    this.dataTable["responsive"].rebuild();
    this.dataTable["responsive"].recalc();

    $('.dropdown-toggle')["dropdown"]();
  }

  getCurrentPageSize(): string {
    if (this.entriesPerPage === 99999) {
      this.limit = 99999;
      return 'All';
    } else {
      return this.entriesPerPage.toString();
    }
  }

  updatePageSize(newSize: number) {
    if (this.entriesPerPage !== newSize) {
      this.entriesPerPage = newSize;
      this.limit = newSize;
    }
    this.paginate(1);
  }

  listLogsByStatusCode(statusCode: string) {
    this.selectedStatusFilter = statusCode;
    if (this.selectedStatusFilter == 'Show All') {
      this.apiStatusFilter = '0';
    } else {
      this.apiStatusFilter = this.selectedStatusFilter.substr(0, 3);
    }

    console.log('status filter' + this.apiStatusFilter);
    console.log('selected filter' + this.selectedStatusFilter);
    this.getLogs();
  }

  searchLogs() {
    if (this.allowSearch) {
      //this is done bc typescript doesnt know the draw method. it accesses a property on what the search is returning

      //this.getLogs();
    }
    this.dataTable.search("").draw();
  }

  allowSearchText(searchText: string) {
    return this.nonSearchableChars.test(searchText);
  }

  validateSearchText() {
    this.allowSearch = ((this.url.trim().length > 0) ||
        (this.request.trim().length > 0) ||
        (this.response.trim().length > 0) ||
        (this.duration.trim().length > 0) ||
        (this.traceId.trim().length > 0) ||
        (this.selectedStatusFilter.trim().length > 0)) &&
      !this.nonSearchableChars.test(this.url) &&
      !this.nonSearchableChars.test(this.request) &&
      !this.nonSearchableChars.test(this.response) &&
      !this.nonSearchableChars.test(this.duration) &&
      !this.nonSearchableChars.test(this.traceId) &&
      !this.nonSearchableChars.test(this.selectedStatusFilter);

    return this.allowSearch;
  }

  searchInputKeyPress(event: any) {
    const inputChar = String.fromCharCode(event.charCode);

    if (this.nonSearchableChars.test(inputChar)) {
      this.allowSearch = false;
    } else {
      this.validateSearchText();
    }
  }

  //Future
  clearSearch() {
    this.url = '';
    this.request = '';
    this.response = '';
    this.duration = '';
    this.traceId = '';
    this.allowSearch = false;

    this.getLogs();
  }
  
}
